import {MAX_PRICES} from '../../utils/constants';

export const getLimitedMaxPrice = (currency = '') => {
    return MAX_PRICES[currency.toUpperCase()] || MAX_PRICES.DEFAULT;
};

export const getLimitedMaxDisplayPrice = (
    maxAllowedPrice: number,
    maxPrice: number | null
) => {
    return maxPrice && Number.isInteger(maxPrice)
        ? Math.min(maxAllowedPrice, maxPrice)
        : maxAllowedPrice;
};
